import intlTelInput from "intl-tel-input";

export default function initInputTel() {
  const input = document.querySelector("#phone");

  intlTelInput(input, {
    initialCountry: "us",
    separateDialCode: true,
    showFlags: false,
    loadUtils: () => import("intl-tel-input/utils"),
  });
}